import styled, { css } from 'styled-components';

const borders = css`
  border-top: 5px solid ${props => props.theme.colors.claytonGreen};
  border-bottom: 5px solid ${props => props.theme.colors.claytonGreen};
`;

export default styled.section`
  padding: 3.875rem ${props => props.theme.padding.inner} 5.1875rem;
  background: ${props => props.theme.colors.claytonBlue};
  ${props => props.borders ? borders : ''};

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 4.875rem ${props => props.theme.padding.inner} 5rem;
  }

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    display: flex;
    flex-direction: column;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .cta {
    color: ${props => props.theme.colors.white};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.popularFaqsContent};
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateX(-10px);
      }

      .active& {
        animation: 0.4s ease-in-out slide-in-down forwards;
      }
    }

    h2 {
      color: inherit;
      margin-top: 0;
      margin-bottom: 1.6875rem;
    }

    .content {
      margin: 0;

      * {
        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    a {
      margin-top: 2rem;
      display: inline-block;
    }
  }

  .faqs {
    margin-top: 3.1875rem;
    flex: 1 1 auto;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.popularFaqsList};
      margin-top: 0;
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateX(-10px);
      }

      .active& {
        animation: 0.4s ease-in-out slide-in-right forwards;
        animation-delay: 0.4s;
      }
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      width: 100%;
    }

    li {
      margin: 0.53125rem 0;
      padding: 0;
      background: ${props => props.theme.colors.white};
      border-radius: 0.25rem;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    a {
      font-size: ${props => props.theme.type.paragraph.intro};
      line-height: ${props => props.theme.lineHeights.paragraph.intro};
      letter-spacing: ${props => props.theme.letterSpacing.paragraph};
      padding: 1rem 3.1875rem 1rem 1rem;
      display: block;
      width: 100%;
      box-sizing: border-box;
      color: ${props => props.theme.colors.bedtime};

      svg {
        margin: 0;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        > path {
          fill: ${props => props.theme.colors.claytonBlue};
        }
      }

      &:hover,
      &:focus,
      &:active {
        svg {
          transform: translate(0.5rem, -50%);
        }
      }

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        padding: 1.375rem 4.3125rem 1.125rem 1.875rem;
      }
    }
  }

  ${props => props.theme.animations.slideInDown};
  ${props => props.theme.animations.slideInRight};
`;
